import shared from "@lab/store/item.shared.module";
import {
	homecareprovider as api,
	mediaImages,
	mediaFiles
} from "@/api/homecare.api";
import { HomeCareProvider } from "@lab/types/homecareprovider";

import Bugsnag from "@/utils/bugsnag";

const state = {
	...shared.state
};

const getters = {
	...shared.getters
};

const actions = {
	async fetch({ commit, dispatch }, providerid: number) {
		commit("LOAD_START");

		const _provider = await api.get(providerid).catch((error) => {
			Bugsnag.notify(
				new Error(
					`Home care provider fetch: ${error.response.data.error}`
				)
			);
		});

		if (_provider) {
			return dispatch(`prepare`, _provider);
		}

		commit(`LOAD_FINISH`);
	},
	async update({ dispatch }, provider: HomeCareProvider) {
		const _provider = await api.update(provider);

		if (provider.images) {
			await mediaImages.update(provider.id, provider.images);
		}

		if (provider.brochures) {
			await mediaFiles.update(provider.id, provider.brochures);
		}

		if (_provider) {
			return dispatch(`prepare`, _provider);
		}
	},
	prepare({ commit }, provider) {
		commit(`LOAD_ITEM_SUCCESS`, provider);
	}
};

const mutations = {
	...shared.mutations
};

export default { namespaced: true, state, getters, actions, mutations };
